import state from './Notice/states'
import mutations from './Notice/mutations'
import actions from './Notice/actions'
import getters from './Notice/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
